import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

const { FiUsers, FiShield, FiMessageCircle, FiArrowRight, FiUser } = FiIcons;

const SupportGroupCard = ({ group, isJoined, onJoin, onLeave }) => {
  return (
    <motion.div 
      layout
      className="bg-white rounded-[40px] overflow-hidden border border-brand-dark hover:border-accent-gold transition-all duration-500 group shadow-sm hover:shadow-2xl"
    >
      <div className="h-48 relative overflow-hidden">
        <img src={group.image} alt={group.name} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        <div className="absolute top-6 left-6">
          <span className="bg-white/20 backdrop-blur-md px-3 py-1 rounded-full text-[9px] font-black uppercase tracking-widest text-white border border-white/20">
            {group.category}
          </span>
        </div>
      </div>

      <div className="p-8">
        <div className="flex justify-between items-start mb-4">
          <h3 className="text-2xl font-serif text-accent-navy group-hover:text-accent-gold transition-colors leading-tight">
            {group.name}
          </h3>
          {group.isVerified && (
            <div className="text-accent-gold" title="Site Verified Group">
              <SafeIcon icon={FiShield} className="w-5 h-5" />
            </div>
          )}
        </div>

        <p className="text-sm text-text-muted font-light leading-relaxed mb-6 line-clamp-2">
          {group.description}
        </p>

        <div className="flex items-center gap-6 mb-8">
          <div className="flex items-center gap-2">
            <SafeIcon icon={FiUsers} className="text-accent-gold w-4 h-4" />
            <span className="text-[10px] font-black uppercase text-text-muted tracking-widest">{group.memberCount} Members</span>
          </div>
          <div className="flex items-center gap-2">
            <SafeIcon icon={FiUser} className="text-accent-gold w-4 h-4" />
            <span className="text-[10px] font-black uppercase text-text-muted tracking-widest">By {group.creator}</span>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          {isJoined ? (
            <div className="flex gap-2">
              <button 
                onClick={() => onLeave(group.id)}
                className="flex-1 py-3 border-2 border-brand-dark rounded-2xl text-[10px] font-black uppercase tracking-widest text-text-muted hover:bg-red-50 hover:text-red-500 transition-all"
              >
                Leave Group
              </button>
              {group.whatsappLink && (
                <a 
                  href={group.whatsappLink} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center justify-center p-3 bg-green-500 text-white rounded-2xl hover:bg-green-600 transition-all shadow-lg shadow-green-200"
                >
                  <SafeIcon icon={FiMessageCircle} className="w-5 h-5" />
                </a>
              )}
            </div>
          ) : (
            <button 
              onClick={() => onJoin(group.id)}
              className="w-full btn-primary py-4 text-[10px] font-black uppercase tracking-[0.2em] flex items-center justify-center gap-2"
            >
              Join Community <SafeIcon icon={FiArrowRight} />
            </button>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default SupportGroupCard;